<template>
  <el-checkbox-group v-model="valueProxy">
    <el-checkbox v-for="item in list" :key="item.value" :label="item.value">
      {{ item.text }}
    </el-checkbox>
  </el-checkbox-group>
</template>
<script>
import { Checkbox, CheckboxGroup } from "element-ui";

/**
 * 填写类型 选择器
 */
export default {
  name: "checkbox-chooser",
  components: {
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
  },
  props: {
    value: {
      type: Number,
    },
    dataSource: {
      type: Array,
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  computed: {
    valueProxy: {
      get() {
        const { value } = this.$props;
        if (value === null || value === undefined) {
          return [];
        }
        return [value];
      },
      set(value) {
        if (value.length) {
          const current = value[value.length - 1];
          this.$emit("update:value", current);
          this.$emit("change", current);
        } else {
          this.$emit("update:value", null);
          this.$emit("change", null);
        }
      },
    },
    list() {
      const { dataSource } = this.$props;
      if (Array.isArray(dataSource)) {
        return dataSource;
      }
      return [];
    },
  },
};
</script>
